import React, { FC } from "react";

import { PaygapHubView } from "@components/main/paygap/PaygapHubView";
import { Box } from "@components/base";

const PaygapHubPage: FC = () => {
  return (
    <Box mb={6}>
      <PaygapHubView />
    </Box>
  );
};

export default PaygapHubPage;
